// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const softvColors: ColorType = {
  ...colorPalette,
  primary: '#0084D4',
  secondary: '#0084D4',
}

export const lightTheme = {
  colors: softvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: softvColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: softvColors.dark,
    secondary: softvColors.grayText,
    disabled: softvColors.dark,
    link: softvColors.dark,
    hint: softvColors.dark,
    highlight: softvColors.primary,
    gray: softvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: softvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: softvColors.dark,
    color: softvColors.dark,
    border: softvColors.primary,
    scrollbarThumb: softvColors.primary,
    programTitle: softvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: softvColors.dark,
        selected: softvColors.dark,
        progress: rgba(softvColors.primary, 0.3),
        past: rgba(softvColors.primary, 0.3),
        pastSelected: softvColors.dark,
        pastHover: softvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(softvColors.primary, 0.1),
      },
      text: {
        empty: softvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: softvColors.dark,
    subTitle: softvColors.grayText,
    bg: softvColors.dark,
    number: softvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    fullBGImage: true,
    fullBGImageSize: 'cover',
    signBGColor: '#252525',
    signLogoSize: 221,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
